module.exports = __webpack_public_path__ + "img/invite-bg.ccb75fd0.png";